<!-- 负荷率 -->

<!-- 智能电力//成本目标  -->
<template>
    <div class="box">
      <Title :text="electricity.LoadRate.Title[0]" :engText="electricity.LoadRate.Title[1]"></Title>
      <div class="content">
        <div class="info">
            <div class="left">
                <div >
                    <div class="big-box white"></div>
                    <div>总数</div>
                </div>
                <div class="a">
                    <span>负荷率:</span>
                    <span class="c-white">98%</span>
                </div>
            </div>
            <div class="border"></div>
            <div class="right">
                <div class="li">
                    <div class="b">
                        <div class="big-box red"></div>
                        <div class="text">消防水泵房</div>
                    </div>
                    <div class="b">
                        <span>负载率：</span>
                        <span>98%</span>
                    </div>
                    
                </div>
                <div class="li">
                    <div class="b">
                        <div class="big-box yellow"></div>
                        <div class="text">海关查验库</div>
                    </div>
                    <div class="b">
                        <span>负载率：</span>
                        <span>98%</span>
                    </div>
                    
                </div>
                <div class="li">
                    <div class="b">
                        <div class="big-box blue"></div>
                        <div class="text">设备用房</div>
                    </div>
                    <div class="b">
                        <span>负载率：</span>
                        <span>98%</span>
                    </div>
                </div>
                <div class="li">
                    <div class="b">
                        <div class="big-box green"></div>
                        <div class="text">检查大厅</div>
                    </div>
                    <div class="b">
                        <span>负载率：</span>
                        <span>98%</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="echarts-content">
            <chart-block ref="echart"></chart-block>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import Title from "../../components/title/index.vue";
import { mapState, mapActions } from "pinia"; //引入映射函数
import useStore from "@/store/index"; //引入store
export default {
  components: {
    Title,
  },
  data () {
    return {
      // active 1:日，2:月，3:年
      active:1,
    }
  },
  computed: {
    ...mapState(useStore, ["electricity"]),
  },
  mounted () {
    this.$refs.echart.setOption(this.electricity.LoadRate.Option);
  },
  methods: {
    
  }
};
  </script>
  
  <style scoped>
  .box{
     width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content{
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /* background-color: red; */
  }
  .content .info{
    width: 100%;
    height: 74px;
    display: flex;
    margin-top: 11px;
  }
  .info .left{
    flex: .35;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .info .right{
    flex: .65;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .info .border{
    width: 1px;
    height: 100%;
    margin-right: 1px;
    border-right: 2px solid #7891b4;
  }
  .left >div{
    display: flex;
    margin: 25px;
    align-items: center;
    margin: 2px 0px 2px 25px;
  }
  .left >div:nth-child(2){
    font-size: 12px;
  }
  .right .li{
    width: 165px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .right .li .b{
    display: flex;
    align-items: center;
    font-size: 12px;
  }
  .right .li .b >span:nth-child(2){
    color: #fff;
  }
  .big-box{
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }
.white{
    background: #fff;
}
.red{
    background: #ff0017;
}
.yellow{
    background: #f7c735;
}
.blue{
    background: #0091ff;
}
.green{
    background: #00ff7e;
}
.c-white{
    color: white;
}
  </style>